(function () {

    angular
        .module('smartertoolsApp')
        .service('refreshToken', ['$http', '$q', '$log', refreshTokenService]);

    function refreshTokenService($http, $q, $log) {
        const vm = this;
        vm.urlBase = apiRootUrl;
        vm.nextRefresh = 0;
        vm.existingRefreshToken = localStorage.getItem('stRefreshToken') || sessionStorage.getItem('stRefreshToken');

        var refreshTokenPromise;

        // Functions
        vm.refreshToken = refreshToken;
        vm.clearCached = clearCached;

        // -----------------------------------------------

        function clearCached() {
            refreshTokenPromise = null;
            vm.nextRefresh = 0;
        }

        function refreshToken() {
            // Is there already a promise underway?  If so, return that
            var tokenPromise = refreshTokenPromise;
            if (tokenPromise) {
                return tokenPromise;
            }

            var defer = $q.defer();
            refreshTokenPromise = defer.promise;

            if (vm.nextRefresh > new Date() && vm.refreshToken) {
                defer.resolve('OK');
                refreshTokenPromise = null;
                return defer.promise;
            }

            $log.debug('refreshing token');

            const refreshToken2 = localStorage.getItem('stRefreshToken') || sessionStorage.getItem('stRefreshToken');
            if (!refreshToken2)
                onRefreshFailed('No Refresh Token');
            else {
                const request = {
                    method: 'POST',
                    url: vm.urlBase + 'v1/auth/refresh-access-token',
                    data: {RefreshToken: refreshToken2}
                };
                $http(request)
                    .then(onRefreshSuccessful)
                    .catch(onRefreshFailed);
            }
            return defer.promise;

            function onRefreshSuccessful(successResponse) {
                localStorage.setItem('stEmail', successResponse.data.EmailAddress);
                sessionStorage.setItem('stAuthToken', successResponse.data.AccessToken);
                vm.nextRefresh = new Date((new Date()).getTime() + 5 * 60000);
                $log.debug(`refresh ok - next at ${vm.nextRefresh}`);
                defer.resolve('OK');
                refreshTokenPromise = null;
            }

            function onRefreshFailed(error) {
                $log.debug(`refresh failed ${error}`);
                defer.reject(error);
                refreshTokenPromise = null;
                if (document.location.href.indexOf('/account') >= 0) {
                    localStorage.removeItem('stEmail');
                    sessionStorage.removeItem('stAuthToken');
                    if (error !== 'No Refresh Token') {
                        document.location = '/';
                    }
                }
            }
        }

    }

})();